package com.essntl.features.proposal.ui.selectservice

import com.essntl.features.service.domain.model.service.ServiceModel

sealed interface SelectServiceNavigation {
    data object AddService : SelectServiceNavigation
    data class EditService(
        val service: ServiceModel,
        val enableEdit: Boolean,
    ) : SelectServiceNavigation
    data class ClickService(val service: ServiceModel) : SelectServiceNavigation
}